import React from 'react';
import { Box, Dialog, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../utils/helpers';

const TrialActivationPopup = ({ open, onClose, startDate, endDate }) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            keepMounted={false}
            aria-labelledby="trial-activation-popup-title"
            PaperProps={{
                sx: {
                    borderRadius: '8px',
                    maxWidth: '500px',
                    width: 'calc(100% - 32px)',
                    p: '16px 24px',
                    m: 1,
                    boxShadow: 3,
                },
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                <IconButton onClick={onClose} size="small" sx={{ ml: -1, mt: -0.5 }}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <Box sx={{ textAlign: 'center', px: 1, pb: 1 }}>
                <Typography id="trial-activation-popup-title" variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
                    {t('SubscriptionPackages.trialActivatedTitle')}
                </Typography>
                <Typography color="text.secondary" variant="body2" sx={{ mb: 1.5 }}>
                    {t('SubscriptionPackages.trialActivatedMessage')}
                </Typography>
                {startDate ? (
                    <Typography variant="body2">
                        {t('SubscriptionPackages.trialStartsFrom')}: {formatDate(startDate)}
                    </Typography>
                ) : null}
                {endDate ? (
                    <Typography variant="body2">
                        {t('SubscriptionPackages.trialEndsAt')}: {formatDate(endDate)}
                    </Typography>
                ) : null}
            </Box>
        </Dialog>
    );
};

export default TrialActivationPopup;
